export default __webpack_public_path__ + "static/media/facebook.9b083280.png";